import { BaseProps } from '@/components/types'
import { ChangeEvent, FocusEvent, KeyboardEvent, useState } from 'react'
import { TableInputWrapper } from '../types/table'

function TablePhoneNumberBox ( props: TablePhoneNumberBoxProps ) {
    const {
        value, width, height = '100%', textAlign = 'right', style, unitText,
        onChange,
        ...rest
    } = props

    const fotmatPhoneNumber = ( value: string | number ): string =>  {
        if ( !value ) return ''

        return String( value ).replace( /[^0-9]/g, '' )
            .replace( /^(\d{0,3})(\d{0,4})(\d{0,4})$/g, '$1-$2-$3' )
            // eslint-disable-next-line no-useless-escape
            .replace( /(\-{1,2})$/g, '' )
    }

    const [ input, setInput ] = useState( fotmatPhoneNumber( value ) )

    const onFocus = ( e: FocusEvent<HTMLInputElement> ) => {
        e?.target.select()
    }

    const onCustomChange = ( e: ChangeEvent<HTMLInputElement> ) => {
        const targetValue = e?.target?.value

        if( !validateInputSize( targetValue ) ) return e.preventDefault()

        setInput( fotmatPhoneNumber( targetValue ) )
        onChange && onChange( removeHyphen( targetValue ) )

        e.preventDefault()
    }

    const removeHyphen = ( value: string ): string => value.replace( /-/g, '' )

    const validateInputSize = ( value: string ): boolean => {
        let valueCheck = true
        const removeRegexValue = removeHyphen( value )

        if ( removeRegexValue.length > 11 ) valueCheck = false

        return valueCheck
    }

    const onKeyDown = ( e: KeyboardEvent<HTMLInputElement> ) => {
        const { code, key } = e
        switch ( code ) {
            case 'Minus':
            case 'NumpadSubtract':
            case 'KeyE':
                e.preventDefault()
                break
            case 'Backspace':
            case 'Period':
                break
        }
    }

    return (
        <div className="table-input-wrapper">
            <div className="table-input-container">
                <input
                    { ...rest }
                    className="table-number-box"
                    value={ input }
                    style={ { textAlign, ...style, width, height, } }
                    onKeyDown={ onKeyDown }
                    onChange={ onCustomChange }
                    onFocus={ onFocus }
                />
                { unitText && <div>{ unitText }</div> }
            </div>
        </div>
    )
}

export default TablePhoneNumberBox

export interface TablePhoneNumberBoxProps extends BaseProps, TableInputWrapper<string> {}